<template>
    <div class="px-3 py-2">
        <v-form ref="forinv" lazy-validation>
            <b-sidebar id="add_device_check" aria-labelledby="sidebar-no-header-title" no-header backdrop width="95%" :style="`direction:`+lang.ldir" right :title="text('add_device_check')" shadow>
                <template #default="{ hide }">
                    <div class="m-1 text-start" :style="`direction:`+lang.dir">
                        <div style="width:160px;margin-inline-start:10px;background:#000;color:#FFF;border-radius:5px" class="btn-primary btn-sm text-center">
                            <span>{{ text('add_device_check') }}</span>
                        </div>
                        <div @click="hide" id="HideDeviceCheckup" style="width:100px;text-align:center;float:left;margin-left:5px;margin-top:-25px;cursor:pointer" class="btn-danger btn-sm">
                            <span>{{ lang.close }}</span>
                        </div>
                    </div>
                    <v-divider></v-divider>
                    <div class="px-3 py-2" :style="`direction:`+lang.dir">
                        <v-row v-if="checkup.id != 0">
                            <v-col cols="12">
                                <div class="backBlack text-center" style="padding:0;width:100%;">
                                    <b-button class="mytab2 btn btn-sm btn-success m-2 shokTbl" style="width:170px;background:darkslategrey !important;" @click="createnew()" v-b-toggle.add_new_card>{{ lang.add_maint_request }}</b-button>
                                </div>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" md="2" sm="6" xs="12">
                                <label>{{ lang.mobile }}</label>
                                <b-form-input class="inborder" v-model="checkup.mobile" @change="getCustomer()" />
                            </v-col>
                            <v-col cols="12" md="2" sm="6" xs="12">
                                <label>{{ lang.customer_name }}</label>
                                <b-form-input class="inborder" v-model="checkup.customer_name" readonly />
                            </v-col>
                            <v-col cols="12" md="2" sm="6" xs="12">
                                <label>{{ lang.owner_name }}</label>
                                <b-form-input class="inborder" v-model="checkup.owner_name" />
                            </v-col>
                            <v-col cols="12" md="2" sm="6" xs="12">
                                <label>{{ lang.delivered_by }}</label>
                                <b-form-input class="inborder" v-model="checkup.delivered_by" />
                            </v-col>
                            <v-col cols="12" md="2" sm="6" xs="12">
                                <label>{{ lang.owner_mobile_number }}</label>
                                <b-form-input class="inborder" v-model="checkup.owner_mobile_number" />
                            </v-col>
                            <v-col cols="12" md="2" sm="6" xs="12">
                                <label>{{ lang.status }}</label>
                                <b-input-group>
                                    <b-form-select class="selborder" v-model="checkup.status" :options="checkStatuss" />
                                    <b-input-group-append :style="`margin-${lang.algin}:-20px;margin-top:5px;`">
                                        <i class="fas fa-arrow-down"></i>
                                    </b-input-group-append>
                                </b-input-group>
                            </v-col>
                            <v-col cols="12" md="2" sm="6" xs="12" v-if="$store.state.licenseType.showCheckBranch">
                                <label>{{ lang.branch_name }}</label>
                                <b-input-group>
                                    <b-form-select class="selborder" v-model="checkup.branch" :options="branchesList" />
                                    <b-input-group-append :style="`margin-${lang.algin}:-20px;margin-top:5px;`">
                                        <i class="fas fa-arrow-down"></i>
                                    </b-input-group-append>
                                </b-input-group>
                            </v-col>
                            <v-col cols="12" md="2" sm="6" xs="12">
                                <label>{{ lang.po_number }}</label>
                                <b-form-input class="inborder" v-model="checkup.po_number" />
                            </v-col>
                        </v-row>

                        <h6 class="section-title">{{ lang.device_info }}</h6>
                        <v-row>
                            <v-col cols="12" md="3" sm="6" xs="12">
                                <label>{{ lang.device_name }}</label>
                                <b-form-input class="inborder required-field" v-model="device.name" />
                            </v-col>
                            <v-col cols="12" md="3" sm="6" xs="12">
                                <label>{{ lang.device_model }}</label>
                                <b-form-input class="inborder" v-model="device.model" />
                            </v-col>
                            <v-col cols="12" md="3" sm="6" xs="12">
                                <label>{{ lang.serial_number }}</label>
                                <b-form-input class="inborder" v-model="device.serial" />
                            </v-col>
                            <v-col cols="12" md="3" sm="6" xs="12">
                                <label>{{ lang.device_accessories }}</label>
                                <b-form-input class="inborder" v-model="device.accessories" />
                            </v-col>
                            <v-col cols="12">
                                <label>{{ lang.device_received_status }}</label>
                                <b-form-input class="inborder" v-model="device.received_status" />
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" md="6" sm="12">
                                <label>{{ lang.device_received_status }}</label>
                                <v-simple-table striped hover style="width:100%;">
                                    <thead>
                                        <tr>
                                            <th class="backBlack" style="border:1px solid black;">{{ lang.description }}</th>
                                            <th class="backBlack text-center" style="border:1px solid black;width:110px;">{{ lang.direction }}</th>
                                            <th class="backBlack text-center" style="border:1px solid black;width:70px;">{{ lang.action }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in checkup.statuses" :key="index">
                                            <td style="border:1px solid black;">
                                                <b-form-input v-model="checkup.statuses[index].description" class="inborder" />
                                            </td>
                                            <td style="border:1px solid black;">
                                                <b-input-group>
                                                    <b-form-select v-model="checkup.statuses[index].direction" :options="checkDirection" class="selborder" />
                                                    <b-input-group-append :style="`margin-${lang.algin}:-20px;margin-top:5px;`">
                                                        <i class="fas fa-arrow-down"></i>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </td>
                                            <td @click="delStatus(index)" style="cursor:pointer;border:1px solid black;background:red !important;color:#fff !important;text-align:center;">
                                                {{ lang.delete }}
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td style="border:1px solid black;">
                                                <b-form-input v-model="statuses.description" class="inborder" />
                                            </td>
                                            <td style="border:1px solid black;">
                                                <b-input-group>
                                                    <b-form-select v-model="statuses.direction" :options="direct" class="selborder" />
                                                    <b-input-group-append :style="`margin-${lang.algin}:-20px;margin-top:5px;`">
                                                        <i class="fas fa-arrow-down"></i>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </td>
                                            <td @click="addStatus()" style="cursor:pointer;border:1px solid black;background:green !important;color:#fff !important;text-align:center;">
                                                {{ lang.add }}
                                            </td>
                                        </tr>
                                    </tfoot>
                                </v-simple-table>
                            </v-col>

                            <v-col cols="12" md="6" sm="12">
                                <label>{{ lang.maintenance_required }}</label>
                                <v-simple-table striped hover style="width:100%;">
                                    <thead>
                                        <tr>
                                            <th class="backBlack" style="width:100px;border:1px solid black;">{{ lang.price }}</th>
                                            <th class="backBlack" style="border:1px solid black;">{{ lang.description }}</th>
                                            <th class="backBlack text-center" style="border:1px solid black;width:80px;">{{ lang.action }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in checkup.maints" :key="index">
                                            <td style="border:1px solid black;">
                                                <b-form-input v-model="checkup.maints[index].price" class="inborder" />
                                            </td>
                                            <td style="border:1px solid black;">
                                                <b-form-input v-model="checkup.maints[index].description" class="inborder" />
                                            </td>
                                            <td @click="delMaint(index)" style="cursor:pointer;border:1px solid black;background:red !important;color:#fff !important;text-align:center;">
                                                {{ lang.delete }}
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td style="border:1px solid black;">
                                                <b-form-input v-model="maints.price" class="inborder" />
                                            </td>
                                            <td style="border:1px solid black;">
                                                <b-form-input v-model="maints.description" class="inborder" />
                                            </td>
                                            <td @click="addMaint()" style="cursor:pointer;border:1px solid black;background:green !important;color:#fff !important;text-align:center;">
                                                {{ lang.add }}
                                            </td>
                                        </tr>
                                    </tfoot>
                                </v-simple-table>
                            </v-col>

                            <v-col cols="12" md="6" sm="12">
                                <label>{{ lang.sparepart_required }}</label>
                                <v-simple-table striped hover style="width:100%;">
                                    <thead>
                                        <tr>
                                            <th class="backBlack" style="width:100px;border:1px solid black;">{{ lang.item_code }}</th>
                                            <th class="backBlack" style="border:1px solid black;">{{ lang.description }}</th>
                                            <th class="backBlack" style="width:100px;border:1px solid black;">{{ lang.price }}</th>
                                            <th class="backBlack text-center" style="border:1px solid black;width:80px;">{{ lang.action }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in checkup.spares" :key="index">
                                            <td style="border:1px solid black;">
                                                <b-form-input v-model="checkup.spares[index].item_code" class="inborder" />
                                            </td>
                                            <td style="border:1px solid black;">
                                                <b-form-input v-model="checkup.spares[index].description" class="inborder" />
                                            </td>
                                            <td style="border:1px solid black;">
                                                <b-form-input v-model="checkup.spares[index].price" class="inborder" />
                                            </td>
                                            <td @click="delSpare(index)" style="cursor:pointer;border:1px solid black;background:red !important;color:#fff !important;text-align:center;">
                                                {{ lang.delete }}
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td style="border:1px solid black;">
                                                <b-form-input v-model="spares.item_code" class="inborder" />
                                            </td>
                                            <td style="border:1px solid black;">
                                                <b-form-input v-model="spares.description" class="inborder" />
                                            </td>
                                            <td style="border:1px solid black;">
                                                <b-form-input v-model="spares.price" class="inborder" />
                                            </td>
                                            <td @click="addSpare()" style="cursor:pointer;border:1px solid black;background:green !important;color:#fff !important;text-align:center;">
                                                {{ lang.add }}
                                            </td>
                                        </tr>
                                    </tfoot>
                                </v-simple-table>
                            </v-col>
                        </v-row>

                        <addNewCard ref="createnew" maintenance-type="general" />
                    </div>
                </template>
                <template #footer="" class="shadow">
                    <div class="d-flex text-light align-items-center px-3 py-5">
                        <b-button type="button" @click="addCheckup()" ref="addButton" id="addDeviceBTN" variant="success" class="ma-2 py-3 btn-sm" style="width:170px;font-size:1.3rem !important;">{{ lang.save_n_print }}</b-button>
                    </div>
                </template>
            </b-sidebar>
        </v-form>
        <vue-snotify></vue-snotify>
    </div>
</template>

<script>
import axios from 'axios'
import {SnotifyPosition} from 'vue-snotify'
import addNewCard from '@/components/addNewCard.vue'

export default {
    components: {addNewCard},
    data() {
        return {
            branches: [],
            receivedProc: [],
            checkUpStatus: [],
            statuses: {
                description: '',
                direction: '',
            },
            maints: {
                item_code: '',
                price: '',
                description: '',
            },
            spares: {
                item_code: '',
                price: '',
                description: '',
            },
            device: this.emptyDevice(),
            checkup: this.emptyCheckup()
        }
    },
    computed: {
        lang: function() {
            if(this.$cookies.get(this.$store.state.LangCooki) != null) {
                if(this.$cookies.get(this.$store.state.LangCooki) == 'en') {
                    return this.$store.state.lang.en;
                } else if(this.$cookies.get(this.$store.state.LangCooki) == 'ur') {
                    return this.$store.state.lang.ur;
                }
                return this.$store.state.lang.ar;
            } else if(this.$store.state.deflang == 'en') {
                return this.$store.state.lang.en;
            } else if(this.$store.state.deflang == 'ur') {
                return this.$store.state.lang.ur;
            }
            return this.$store.state.lang.ar;
        },
        checkStatuss: function() {
            let t = [];
            for(let i = 0; i < this.checkUpStatus.length; i++) {
                t.push({text: this.checkUpStatus[i][`name_${this.lang.langname}`], value: this.checkUpStatus[i][`name_${this.lang.langname}`]})
            }
            return t;
        },
        checkDirection: function() {
            let t = [];
            for(let i = 0; i < this.receivedProc.length; i++) {
                t.push({text: this.receivedProc[i][`name_${this.lang.langname}`], value: this.receivedProc[i][`name_${this.lang.langname}`]})
            }
            return t;
        },
        direct: function() {
            return this.checkDirection;
        },
        branchesList: function() {
            let t = [];
            for(let i = 0; i < this.branches.length; i++) {
                t.push({text: this.branches[i][`name_${this.lang.langname}`], value: this.branches[i][`name_${this.lang.langname}`]})
            }
            return t;
        },
    },
    methods: {
        text(key) {
            return this.lang[key] || key;
        },
        emptyDevice() {
            return {
                name: '',
                model: '',
                serial: '',
                accessories: '',
                received_status: '',
            }
        },
        emptyCheckup() {
            return {
                path_number: 0,
                id: 0,
                branch: '',
                checkup_type: 2,
                ch_type: 3,
                mobile: '',
                customer_name: '',
                customer_id: 0,
                contract_number: 0,
                plate_number: '',
                brand: '',
                model: '',
                made_year: '',
                color: '',
                vin: '',
                engine_meter: '',
                owner_name: '',
                delivered_by: '',
                statuses: [],
                maints: [],
                spares: [],
                itemsIn: [],
                images: '',
                status: 1,
                owner_mobile_number: '',
                po_number: '',
                transport: '',
            }
        },
        notify(message) {
            this.$snotify.error(message, this.lang.alert, {
                timeout: 1000000,
                showProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                position: SnotifyPosition.centerCenter,
                buttons: [
                    {
                        text: this.lang.close,
                        action: (toast) => {
                            this.$snotify.remove(toast.id);
                        }
                    },
                ]
            });
        },
        parseDeviceInfo(row) {
            if(!row) return this.emptyDevice();
            let info = {};
            if(row.device_info && typeof row.device_info === 'object') {
                info = row.device_info;
            } else if(row.transport && typeof row.transport === 'object') {
                info = row.transport;
            } else if(row.transport) {
                try {
                    info = JSON.parse(row.transport);
                } catch (_error) {
                    info = {};
                }
            }

            return {
                name: info.device_name || info.name || row.brand || '',
                model: info.device_model || info.model || row.model || '',
                serial: info.serial_number || info.serial || row.plate_number || row.vin || '',
                accessories: info.accessories || '',
                received_status: info.received_status || '',
            }
        },
        preparePayload() {
            const deviceInfo = {
                maintenance_type: 'device',
                device_name: this.device.name,
                name: this.device.name,
                device_model: this.device.model,
                model: this.device.model,
                serial_number: this.device.serial,
                serial: this.device.serial,
                accessories: this.device.accessories,
                received_status: this.device.received_status,
            };

            this.checkup.ch_type = 3;
            this.checkup.checkup_type = 2;
            this.checkup.brand = this.device.name;
            this.checkup.model = this.device.model;
            this.checkup.plate_number = this.device.serial;
            this.checkup.vin = this.device.serial;
            this.checkup.color = '';
            this.checkup.made_year = '';
            this.checkup.engine_meter = '';
            this.checkup.images = '';
            this.checkup.itemsIn = [];
            this.checkup.transport = JSON.stringify(deviceInfo);
            this.checkup.device = deviceInfo;
        },
        async createnew() {
            await this.$refs.createnew.resetValues();
            this.$refs.createnew.checkUpId = this.checkup.id;
            await this.$refs.createnew.getInvSettings();
            this.$refs.createnew.getCheckup();
        },
        getBranchesList() {
            const post = new FormData();
            post.append('defBranch', localStorage.getItem('defBranch'));
            post.append('financeYear', localStorage.getItem('financeYear'));
            post.append('type', 'getStaticOptions');
            post.append('auth', this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[phrase]', 'BranchesList');
            axios.post(this.$store.state.SAMCOTEC.r_path, post).then((response) => {
                this.branches = response.data.results.data;
            });
        },
        getreceivedProc() {
            const post = new FormData();
            post.append('defBranch', localStorage.getItem('defBranch'));
            post.append('financeYear', localStorage.getItem('financeYear'));
            post.append('type', 'getStaticOptions');
            post.append('auth', this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[phrase]', 'receivedProc');
            axios.post(this.$store.state.SAMCOTEC.r_path, post).then((response) => {
                this.receivedProc = response.data.results.data;
                if(this.statuses.direction == '' && this.receivedProc.length > 0) {
                    this.statuses.direction = this.receivedProc[0][`name_${this.lang.langname}`];
                }
            });
        },
        getStatics() {
            const post = new FormData();
            post.append('defBranch', localStorage.getItem('defBranch'));
            post.append('financeYear', localStorage.getItem('financeYear'));
            post.append('type', 'getStaticOptions');
            post.append('auth', this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[phrase]', 'checkUpStatuses');
            axios.post(this.$store.state.SAMCOTEC.r_path, post).then((response) => {
                this.checkUpStatus = response.data.results.data;
            });
        },
        getCheckup(id) {
            const post = new FormData();
            post.append('defBranch', localStorage.getItem('defBranch'));
            post.append('financeYear', localStorage.getItem('financeYear'));
            post.append('type', 'getCurrentCheckup');
            post.append('auth', this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[id]', id);
            post.append('data[ch_type]', 3);
            axios.post(this.$store.state.SAMCOTEC.r_path, post).then((response) => {
                if(response.data.results.data.length == 0) {
                    return false;
                }
                const res = response.data.results.data[0];
                this.checkup = {
                    path_number: res.path_number || 0,
                    id: res.id,
                    branch: res.branch || '',
                    checkup_type: res.checkup_type || 2,
                    ch_type: 3,
                    mobile: res.mobile || '',
                    customer_name: res.customer_name || '',
                    customer_id: res.customer_id || 0,
                    contract_number: res.contract_number || 0,
                    plate_number: res.plate_number || '',
                    brand: res.brand || '',
                    model: res.model || '',
                    made_year: res.made_year || '',
                    color: res.color || '',
                    vin: res.vin || '',
                    engine_meter: res.engine_meter || '',
                    owner_name: res.owner_name || '',
                    delivered_by: res.delivered_by || '',
                    statuses: res.statuses || [],
                    maints: res.maints || [],
                    spares: res.spares || [],
                    itemsIn: [],
                    images: '',
                    status: res.status || 1,
                    owner_mobile_number: res.owner_mobile_number || '',
                    po_number: res.po_number || '',
                    transport: res.transport || '',
                };
                this.device = this.parseDeviceInfo(res);
            });
        },
        addCheckup() {
            let message = '';
            if(this.checkup.mobile == '' || this.checkup.customer_name == '' || this.checkup.customer_id == 0) {
                message = this.lang.customer_required;
            } else if(this.device.name == '') {
                message = this.lang.device_name_required;
            } else if(this.checkup.statuses.length == 0) {
                message = this.text('please_add_one_device_received_status');
            } else if(this.checkup.maints.length == 0) {
                message = this.text('please_add_one_device_maintenance');
            }

            if(message != '') {
                this.notify(message);
                return false;
            }

            if(this.checkup.branch == '') {
                this.checkup.branch = this.branchesList.length > 0 ? this.branchesList[0].value : '';
            }
            this.preparePayload();

            const post = new FormData();
            post.append('defBranch', localStorage.getItem('defBranch'));
            post.append('financeYear', localStorage.getItem('financeYear'));
            post.append('type', 'addCheckup');
            post.append('auth', this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[checkup]', JSON.stringify(this.checkup));
            this.$refs.addButton.disabled = true;
            axios.post(this.$store.state.SAMCOTEC.r_path, post).then(() => {
                this.notify(this.lang.added_successfuly);
                document.getElementById('HideDeviceCheckup').click();
                this.$parent.getCheckup();
            }).catch(() => {
                this.$refs.addButton.disabled = false;
            });
        },
        addStatus() {
            if(this.statuses.description == '') {
                this.notify(this.lang.description_required);
                return false;
            }
            this.checkup.statuses.push({description: this.statuses.description, direction: this.statuses.direction});
            this.statuses.description = '';
        },
        addMaint() {
            if(this.maints.description == '') {
                this.notify(this.lang.description_required);
                return false;
            }
            this.checkup.maints.push({description: this.maints.description, item_code: this.maints.item_code, price: this.maints.price});
            this.maints.item_code = '';
            this.maints.description = '';
            this.maints.price = '';
        },
        addSpare() {
            if(this.spares.description == '') {
                this.notify(this.lang.description_required);
                return false;
            }
            this.checkup.spares.push({description: this.spares.description, item_code: this.spares.item_code, price: this.spares.price});
            this.spares.item_code = '';
            this.spares.description = '';
            this.spares.price = '';
        },
        delStatus(index) {
            this.checkup.statuses.splice(index, 1);
        },
        delMaint(index) {
            this.checkup.maints.splice(index, 1);
        },
        delSpare(index) {
            this.checkup.spares.splice(index, 1);
        },
        reset() {
            this.checkup = this.emptyCheckup();
            this.device = this.emptyDevice();
            this.statuses.description = '';
            this.maints = {item_code: '', price: '', description: ''};
            this.spares = {item_code: '', price: '', description: ''};
        },
        getCustomer() {
            if(this.checkup.mobile == '') return false;
            const post = new FormData();
            post.append('defBranch', localStorage.getItem('defBranch'));
            post.append('financeYear', localStorage.getItem('financeYear'));
            post.append('type', 'customerInfoAll');
            post.append('auth', this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[mobile]', this.checkup.mobile);
            axios.post(this.$store.state.SAMCOTEC.r_path, post).then((response) => {
                if(response.data.results.data.length == 0) {
                    this.notify(this.text('customer_required'));
                    return false;
                }
                const customer = response.data.results.data[0];
                this.checkup.customer_id = customer.id;
                if(customer.customer_type == 2) {
                    this.checkup.customer_name = customer.company_name;
                } else if(customer.customer_type == 1) {
                    this.checkup.customer_name = customer.full_name;
                } else if(customer.customer_type == 3) {
                    this.checkup.customer_name = customer.entity_name;
                }
            });
        }
    },
    created() {
        this.getreceivedProc();
        this.getBranchesList();
        this.getStatics();
    }
}
</script>

<style scoped>
.section-title {
    background: lightblue;
    color: #000 !important;
    font-weight: bold;
    padding: 3px;
    margin-bottom: 10px;
    margin-top: 10px;
    text-align: center;
}
.required-field {
    background: #fff700 !important;
}
</style>
